
<template>
  <div :class="$style.tgStore">
    <h1>
      <!-- <img :src="`${$cdnUrl}/tgStore/xiangzuo.png`" alt=""> -->
      <span>{{ title }}——道具商城</span>
    </h1>
    <img :src="back" alt="" :class="$style.banner" />
    <div :class="$style.game">
      <div :class="$style.gameInfo">
        <img :src="logo" alt="" />
        <div>
          <p :class="$style.title">{{ title }}</p>
          <p v-if="userInfo.account">账号：{{ userInfo.account }}</p>
          <p v-if="userInfo.mobile">手机号：{{ userInfo.mobile }}</p>
          <p v-if="userInfo.role">
            区服：{{ userInfo.server }}&nbsp;&nbsp;&nbsp;&nbsp; 角色：{{ userInfo.role }}
          </p>
        </div>
      </div>
      <ul :class="$style.operate">
        <li @click="showBind">
          <img :src="`${$cdnUrl}/tgStore/switch.png`" alt="" />
          <span>{{ userInfo.role ? '切换角色' : '绑定角色' }}</span>
        </li>
        <li @click="showRecord">
          <img :src="`${$cdnUrl}/tgStore/record.png`" alt="" />
          <span>购买记录</span>
        </li>
        <li @click="contactKf">
          <img :src="`${$cdnUrl}/tgStore/contact.png`" alt="" />
          <span>联系客服</span>
        </li>
      </ul>
    </div>
    <div :class="$style.product">
      <div :class="$style.tabs">
        <div :class="$style.tabsItem">
          <div
            v-for="st in subShopList"
            :key="st.id"
            :class="[activeTab === st.id ? $style.active : '']"
            @click="changeTab(st.id)"
          >
            <span>{{ st.name }}</span>
          </div>
        </div>
      </div>
      <!-- type 为 1 则是周商城 -->
      <!-- v-if="currentSubStoreInfo.type === 1" -->
      <span
        :class="[$style.hint, $style.white_space_pre]"
      >{{ currentSubStoreInfo.rules || '' }}</span>
       <!-- 【消费可激活游戏内首充/累充活动,助您游玩仙界畅通无阻】 -->
      <div
        :class="[$style.hint_2, $style.white_space_pre]"
      >{{ currentSubStoreInfo.introduce || '' }}</div>
      <ul :class="$style.productList">
        <li v-for="(item, index) in currentSubStoreGoods" :key="index" @click="showGoodsDetail(item)">
          <img :src="item.icon" alt="" />
          <div :class="$style.detail">
            <p :class="$style.name">{{ item.name }}</p>
            <p :class="$style.price">
              <span :class="$style.discount" v-if="item.discount">{{ item.discount }}</span>
              <span :class="$style.price">￥{{ item.price }}</span>
              <span :class="$style.original" v-if="item.original_price"
                >原价￥{{ item.original_price }}</span
              >
            </p>
            <p :class="$style.purchase">
              <span v-if="activeTab === 1 && item.quota > 0">每周</span
              ><span v-if="item.quota > 0">限购{{ item.quota }}份</span>
              <span v-if="item.quota == 0" :class="$style.bl">不限购</span>
              <span :class="$style.bl" v-if="item.quota > 0"
                >（{{ item.buy }}/{{ item.quota }}）</span
              >
            </p>
            <p :class="$style.endTime" v-if="item.show_state != 2">
              下架时间：<span>{{ item.end_time }}</span>
            </p>
            <p :class="$style.endTime" v-if="item.show_state == 2">
              上架时间：<span>{{ item.start_time }}</span>
            </p>
          </div>
          <div :class="$style.storeOperate">
            <button v-if="item.show_state == 1" @click.stop="buyGoods(item)">购买</button>
            <button v-if="item.show_state == 2" :class="$style.pre" @click.stop>即将上架</button>
            <button v-if="item.show_state == 3" :class="$style.run" @click.stop>已售罄</button>
            <p>剩余{{ item.surplus }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div :class="$style.bindMask" v-if="bindShow">
      <div :class="$style.bind">
        <h1>
          <span>绑定角色</span>
          <img :src="`${$cdnUrl}/tgStore/close.png`" alt="" @click="closeBind" />
        </h1>

        <div :class="$style.content">
          <p
            style="font-size: 10px; text-align: center; color: #bebebe; margin-bottom: 15px"
            v-if="bind_type == 2 && serverList.length == 0"
          >
            可通过当前游戏账号绑定的手机号+短信进行账号验证
          </p>
          <!-- 绑定账号 -->
          <p v-if="userInfo.account && !updateBindFlag && userInfo.bind_type == 1">
            当前绑定账号：
          </p>
          <p
            :class="$style.accountView"
            v-if="userInfo.account && !updateBindFlag && userInfo.bind_type == 1"
          >
            <span :class="$style.account">{{ userInfo.account }}</span>
            <span :class="$style.btn" @click="changeAccount">更换账号</span>
          </p>
          <!-- 绑定手机号 -->
          <p v-if="userInfo.mobile && !updateBindFlag && userInfo.bind_type == 2">
            当前绑定手机号：
          </p>
          <p
            :class="$style.accountView"
            v-if="userInfo.mobile && !updateBindFlag && userInfo.bind_type == 2"
          >
            <span :class="$style.account">{{ userInfo.mobile }}</span>
            <span :class="$style.btn" @click="changeAccount">更换手机号</span>
          </p>
          <!-- 手机登录 -->
          <div v-if="bind_type == 2 && serverList.length == 0">
            <p v-if="!userInfo.account || updateBindFlag">绑定手机号：</p>
            <Field
              v-model.trim="phoneNumber"
              :class="$style.field"
              type="tel"
              clearable
              error-message-align="right"
            ></Field>
            <p v-if="!userInfo.account || updateBindFlag">验证码：</p>
            <Field
              v-model.trim="phoneCode"
              :class="$style.field"
              type="tel"
              clearable
              error-message-align="right"
            ></Field>

            <Button
              :class="$style['get-code-btn']"
              size="mini"
              type="info"
              plain
              round
              @click="getVerifyCode"
              v-if="!hasVerifyCode"
            >
              获取
            </Button>
            <CountDown
              ref="countDown"
              seconds
              :time="60000"
              format="ss 秒后重发"
              :auto-start="true"
              :style="{ color: '#ccc', fontSize: '12px' }"
              v-if="hasVerifyCode"
              @finish="hasVerifyCode = fasle"
            >
            </CountDown>
            <div style="text-align: center; color: #6b99e6; margin-top: 10px" @click="changeType">
              切换至账号密码验证
            </div>
          </div>
          <!-- 账号密码 -->
          <div v-if="bind_type == 1 && serverList.length == 0">
            <p v-if="!userInfo.account || updateBindFlag">游戏账号：</p>
            <Field
              v-if="!userInfo.account || updateBindFlag"
              v-model.trim="account"
              :class="$style.field"
            ></Field>
            <p v-if="!userInfo.account || updateBindFlag">密码：</p>
            <Field
              v-model.trim="password"
              :class="$style.field"
              type="password"
              v-if="!userInfo.account || updateBindFlag"
            ></Field>
            <div style="text-align: center; color: #6b99e6; margin-top: 25px" @click="changeType">
              切换至手机验证码验证
            </div>
          </div>

          <div v-if="serverList.length != 0">
            <p>选择区服：</p>
            <CSelect
              placeholder="请选择区服"
              :options="serverList"
              :value="server"
              @change="selectServer"
              ref="selectServer"
              @select="$refs.selectRole.active = false"
            ></CSelect>
            <p>选择角色：</p>
            <CSelect
              ref="selectRole"
              placeholder="请选择角色"
              :options="roleList"
              :value="role"
              @change="selectRole"
              @select="$refs.selectServer.active = false"
            ></CSelect>
          </div>
        </div>
        <div :class="$style.btnGroup">
          <!-- <Button :class="$style.nextStep" @click="handleInputBlur" v-if="updateBindFlag||isSelectServer">选择区服</Button> -->
          <Button
            :class="$style.nextStep"
            @click="handleInputBlur"
            v-if="serverList.length == 0"
            style="margin-top: 20px"
            >选择区服</Button
          >
          <Button :class="$style.nextStep" @click="bindRole" v-else>确认绑定</Button>
        </div>
      </div>
    </div>
    <div :class="$style.bindMask" v-if="goodsDetailShow">
      <div :class="$style.intro">
        <h1>
          <span>道具简介</span>
          <img :src="`${$cdnUrl}/tgStore/close.png`" alt="" @click="goodsDetailShow = false" />
        </h1>
        <p>{{ introduce }}</p>
      </div>
    </div>
    <!-- 选择账号弹窗 -->
    <AccountSelectDialog
      ref="accountSelectDialog"
      dialogType="2"
      @select="handleAccountSelect"
    />

    <div :class="$style.bindMask" v-if="errorTipShow">
      <div :class="$style.intro">
        <h1>
          <span>访问异常</span>
        </h1>
        <p>当前账号无法访问道具商城，请使用其他账号访问。</p>
      </div>
    </div>
  </div>
</template>

<script>
import Parent from './store.vue';
import { check_cut_user_auth } from '@/api/tgStore';
export default {
  name: 'cutUserStore',
  extends: Parent,
  data() {
    return {
      errorTipShow: false,
    }
  },
  mounted () {
    // this.initStore();
  },
  methods: {
    async initStore() {
      
      const errorTip = localStorage.getItem('cutUserErrorTip');
      if (errorTip) {
        this.errorTipShow = true;
        return;
      }
      const { config_id, tab_id, good_id, lead_id, order_token ,origin_id} = this.$route.query;
      this.configId = config_id;
      this.originId = origin_id;
      if (!order_token || !lead_id) {
        this.errorTipShow = true;
        return;
      }

      try {
        const res = await check_cut_user_auth({ lead_id, order_token });
        const { status = '' } = res.data;
        if (status !== 1) {
          this.errorTipShow = true;
          return;
        }
      } catch (error) {
        this.errorTipShow = true;
        return;
      }
      
      // 如果URL中有tab_id参数，记录以便稍后设置激活标签
      if (tab_id) {
        this.activeTab = Number(tab_id);
      }
      
      // 如果URL中有good_id参数，记录以便稍后高亮显示
      if (good_id) {
        this.highlightGoodId = good_id;
      }
      
      this.getUserInfo();
      this.getConfig().then(res => {
        this.getProductList().then(() => {
          // 在获取商品列表后，进行商品高亮和滚动处理
          this.$nextTick(() => {
            this.scrollToHighlightedGood();
          });
        });
      })
      shopData({ type: 1, config_id: this.originId });
    }
  }
}
</script>